import { render, staticRenderFns } from "./ListMenuAddress.vue?vue&type=template&id=7728f239&"
import script from "./ListMenuAddress.vue?vue&type=script&lang=ts&"
export * from "./ListMenuAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports